var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStructure12865486(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.981,
    height: 20,
    viewBox: "0 0 19.981 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "structure_12865486",
    d: "M.24,10A5.177,5.177,0,1,0,5.417,4.823,5.182,5.182,0,0,0,.24,10ZM13.215,2.6V9.766h1.67a.234.234,0,0,1,0,.469h-1.67V17.4h1.67a.234.234,0,0,1,0,.469h-1.9a.234.234,0,0,1-.234-.234v-7.4H11.529a.234.234,0,1,1,0-.469h1.217V2.37a.234.234,0,0,1,.234-.234h1.9a.234.234,0,1,1,0,.469ZM20.221,17.63A2.37,2.37,0,1,0,17.852,20a2.369,2.369,0,0,0,2.37-2.37ZM17.852,0a2.37,2.37,0,1,0,2.37,2.37A2.37,2.37,0,0,0,17.852,0Zm0,7.63A2.37,2.37,0,1,0,20.221,10a2.37,2.37,0,0,0-2.37-2.37Z",
    transform: "translate(-0.24)",
    fill: "#7d96ff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStructure12865486);
export default __webpack_public_path__ + "static/media/structure_12865486.cce6dca3995a7e83715ca38a06d6226b.svg";
export { ForwardRef as ReactComponent };